import React from 'react';

function CreateBookingModal({
  show, form, setForm, instances, formatDate,
  sendConfirmation, setSendConfirmation, error, loading,
  onSubmit, onClose, onInstanceChange, onAddParticipant, onRemoveParticipant, onUpdateParticipant
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <h2>Ny bokning</h2>
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={onSubmit}>
          <h3 className="form-section-title">Kurstillfälle</h3>
          <div className="form-group">
            <label>Välj kurstillfälle *</label>
            <select value={form.courseInstanceId} onChange={(e) => onInstanceChange(e.target.value)} required>
              <option value="">-- Välj kurstillfälle --</option>
              {instances.map(inst => (
                <option key={inst.id} value={inst.id}>
                  {inst.course?.name} - {formatDate(inst.startDate)} ({inst.location})
                </option>
              ))}
            </select>
          </div>

          <h3 className="form-section-title">
            Deltagare ({form.participants.length})
            <button type="button" className="btn btn-small btn-secondary" style={{ marginLeft: 12 }}
              onClick={onAddParticipant}>+ Lägg till deltagare</button>
          </h3>
          {form.participants.map((p, i) => (
            <div key={i} className="participant-block">
              {form.participants.length > 1 && (
                <div className="participant-header">
                  <span className="participant-number">Deltagare {i + 1}</span>
                  <button type="button" className="btn-icon-remove" onClick={() => onRemoveParticipant(i)}
                    title="Ta bort deltagare">×</button>
                </div>
              )}
              <div className="form-row">
                <div className="form-group">
                  <label>Förnamn *</label>
                  <input type="text" required value={p.firstName}
                    onChange={(e) => onUpdateParticipant(i, 'firstName', e.target.value)} />
                </div>
                <div className="form-group">
                  <label>Efternamn *</label>
                  <input type="text" required value={p.lastName}
                    onChange={(e) => onUpdateParticipant(i, 'lastName', e.target.value)} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>E-post *</label>
                  <input type="email" required value={p.email}
                    onChange={(e) => onUpdateParticipant(i, 'email', e.target.value)} />
                </div>
                <div className="form-group">
                  <label>Telefon</label>
                  <input type="tel" value={p.phone}
                    onChange={(e) => onUpdateParticipant(i, 'phone', e.target.value)} />
                </div>
              </div>
              <div className="form-group">
                <label>Specialkost / Allergier</label>
                <input type="text" value={p.specialDiet}
                  onChange={(e) => onUpdateParticipant(i, 'specialDiet', e.target.value)}
                  placeholder="T.ex. vegetarisk, glutenfri..." />
              </div>
            </div>
          ))}

          <h3 className="form-section-title">Företags- och fakturainformation</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Företag</label>
              <input type="text" value={form.company}
                onChange={(e) => setForm({...form, company: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Organisationsnummer</label>
              <input type="text" value={form.organizationNumber}
                onChange={(e) => setForm({...form, organizationNumber: e.target.value})}
                placeholder="XXXXXX-XXXX" />
            </div>
          </div>
          <div className="form-group">
            <label>Fakturaadress</label>
            <textarea value={form.billingAddress}
              onChange={(e) => setForm({...form, billingAddress: e.target.value})}
              rows="2" placeholder="Gatuadress, postnummer, ort..." />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Fakturareferens</label>
              <input type="text" value={form.invoiceReference}
                onChange={(e) => setForm({...form, invoiceReference: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Kostnadsställe</label>
              <input type="text" value={form.costCenter}
                onChange={(e) => setForm({...form, costCenter: e.target.value})} />
            </div>
          </div>

          <h3 className="form-section-title">Pris och övrigt</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Pris (kr)</label>
              <input type="number" value={form.price}
                onChange={(e) => setForm({...form, price: e.target.value})}
                placeholder="0" min="0" step="1" />
            </div>
          </div>
          <div className="form-group">
            <label>Anteckningar</label>
            <textarea value={form.notes}
              onChange={(e) => setForm({...form, notes: e.target.value})}
              rows="2" placeholder="Interna anteckningar..." />
          </div>

          <div className="send-confirmation-toggle">
            <label>
              <input type="checkbox" checked={sendConfirmation}
                onChange={(e) => setSendConfirmation(e.target.checked)} />
              Skicka bokningsbekräftelse via e-post
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? 'Skapar...' : form.participants.length > 1
                ? `Skapa ${form.participants.length} bokningar`
                : 'Skapa bokning'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Avbryt</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateBookingModal;
